import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ZoneService {
  protected endpoint: string;

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager/provider/zones';
  }

  cleanPayload(rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(([_, v]) => v !== null)
    );
  }

  async createProviderCustomZone(payload: Record<string, any>) {
    payload = this.cleanPayload(payload);

    const response: any = await firstValueFrom(
      this.apiService.post('rate-manager/provider/custom-zones', payload)
    );

    return response.data;
  }

  async getProviderZones(payload: Record<string, any> = {}) {
    payload = this.cleanPayload(payload);

    const response: any = await firstValueFrom(
      this.apiService.get(`rate-manager/provider/zones-by-provider`, payload, true)
    );

    return response.data;
  }

  async getZones(payload: Record<string, any> = {}) {
    payload = this.cleanPayload(payload);

    const response: any = await firstValueFrom(
      this.apiService.get(this.endpoint, payload, true)
    );

    const data = response.data;

    return data.map((zone: any) => ({
      value: zone.id,
      label: zone.name,
    }));
  }

  async getSuburb(payload: Record<string, any> = {}) {
    payload = this.cleanPayload(payload);

    const response: any = await firstValueFrom(
      this.apiService.get(`rate-manager/provider/suburbs`, payload, true)
    );

    const data = response.data;

    return data.map((suburb: any) => ({
      value: suburb.id,
      label: suburb.name,
    }));
  }

  async submitZone(payload: Record<string, any>) {
    if (!(payload instanceof FormData)) {
      payload = this.cleanPayload(payload);
    }

    const response: any = await firstValueFrom(
      this.apiService.post(this.endpoint, payload, true)
    );

    return response.data;
  }

  async syncZones() {
    const response: any = await firstValueFrom(
      this.apiService.post(`${this.endpoint}/sync-from-master`, {}, true)
    );

    return response;
  }

  async deleteZone(id: number) {
    return await firstValueFrom(this.apiService.delete(`${this.endpoint}/${id}`));
  }

  async submitZoneBulk(formData: FormData): Promise<any> {
    return await this.apiService.post(`${this.endpoint}/zones/bulk-upload/`, formData).toPromise();
  }

  downloadZoneTemplate(): Observable<string> {
    const options = { responseType: 'text' as const };
    return this.apiService.get(
      `${this.endpoint}/download-template`,
      {},
      false,
      options
    );
  }
}
